import loading from './loading.gif'
const Loading = () =>{
    return(<>
    <div className='d-flex justify-content-center' style={{width:'100%', height:'100%', position:'fixed', top:'0px', zIndex:'1000000', backgroundColor:'white'}}>
        <img src={loading} />
    </div>
    </>)
}

export default Loading;